.infoText {
  color: var(--body-text-arrows-400);
}

gz-form-field {
  --form-field-label-width: 350px;
}

.form-field-info-text {
  padding-top: calc(var(--spacer) * 1);
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-info-box {
  padding-left: calc(var(--spacer) * -1);
}
